import { useQuery } from '@tanstack/react-query';

import { electronApis } from '@/features/electron-api';
import { inBrowser } from '@/utils/capabilities';

export interface EventKitSource {
  id: string;
  name: string;
  color: string;
  sourceName: string | null;
  isWritable: boolean;
}

const EVENTKIT_SOURCE_FALLBACK_COLOR = '#8e8e93';

export const integrationConfigurationKeys = {
  reminderLists: () =>
    ['integration-configuration', 'eventkit', 'reminder-lists'] as const,
};

export function useReminderListsQuery(enabled: boolean) {
  return useQuery({
    queryKey: integrationConfigurationKeys.reminderLists(),
    queryFn: async (): Promise<EventKitSource[]> => {
      const sources = await electronApis.eventKit.getReminderLists();

      return sources.map((source) => ({
        id: source.id,
        name: source.title,
        color: source.colorHex ?? EVENTKIT_SOURCE_FALLBACK_COLOR,
        sourceName: source.sourceName ?? null,
        isWritable: source.isWritable,
      }));
    },
    enabled: enabled && !inBrowser(),
  });
}
